import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import VideoBlock from "./VideoBlock";
import Reveal from "./Reveal";
import { VIDEOS } from "@/lib/content";

const Philosophy = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const videoY = useTransform(scrollYProgress, [0, 1], [50, -50]);
  const textY = useTransform(scrollYProgress, [0, 1], [-20, 20]);

  return (
    <section
      id="filosofia"
      ref={ref}
      data-testid="philosophy-section"
      className="et-section relative overflow-hidden"
    >
      <div
        aria-hidden
        className="et-orb"
        style={{
          top: "30%",
          left: "-10%",
          width: "520px",
          height: "520px",
          background: "#c5a059",
          opacity: 0.12,
        }}
      />

      <div className="et-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Video — blended into bg */}
          <motion.div style={{ y: videoY }} className="lg:col-span-6 relative">
            <Reveal>
              <VideoBlock
                src={VIDEOS.philosophy}
                aspect="aspect-square sm:aspect-[5/4] lg:aspect-[4/5]"
                testId="philosophy-video"
                variant="blend"
              />
            </Reveal>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.3 }}
              className="mt-4 flex items-center justify-center gap-3"
            >
              <span className="text-[11px] md:text-xs uppercase tracking-[0.22em] text-[#c5a059]">
                Caos → Orden → Sistema
              </span>
            </motion.div>
          </motion.div>

          {/* Text right */}
          <motion.div style={{ y: textY }} className="lg:col-span-6">
            <Reveal>
              <div className="et-eyebrow">Filosofía</div>
            </Reveal>

            <Reveal delay={0.08}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
                La IA no arregla un mal proceso.{" "}
                <span className="et-text-gold">Lo acelera.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.16}>
              <p className="mt-5 text-base md:text-lg text-[#f5f2ea]/90 leading-relaxed max-w-xl">
                Antes de automatizar, hay que saber qué proceso merece la pena
                mejorar. Si no, solo tendrás herramientas más rápidas haciendo
                cosas que no deberías estar haciendo.
              </p>
            </Reveal>

            <Reveal delay={0.24}>
              <div className="mt-7 flex items-center gap-3 flex-wrap">
                {["Primero orden", "Luego sistema", "Después automatización"].map(
                  (s, i) => (
                    <React.Fragment key={s}>
                      <span className="text-sm md:text-base text-white font-semibold tracking-tight">
                        {s}
                      </span>
                      {i < 2 && (
                        <span className="text-[#c5a059]/70 text-lg">→</span>
                      )}
                    </React.Fragment>
                  )
                )}
              </div>
            </Reveal>

            <Reveal delay={0.32}>
              <div className="mt-8 border-l-2 border-[#c5a059] pl-5 max-w-md">
                <p className="text-sm md:text-base text-[#f5f2ea]/90 italic leading-relaxed">
                  &ldquo;Prueba barato. Mide. Aprende. Repite lo que funciona.&rdquo;
                </p>
              </div>
            </Reveal>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
